<template lang="pug">
  div.inherit
    van-form(@submit="onSubmit", v-if="showPageOne")
        van-field(class="inherit_form", type="password", v-model="newpwd", :placeholder="$t('plzInputPwd')", :rules="[{required: true, message: this.$t('plzInputPwd')},{validator: pwdValidator, message: pwdmsg}]")
        van-field(class="inherit_form", type="password", v-model="repeatpwd", :placeholder="$t('plzInputPwdAgain')", :rules="[{required: true, message: this.$t('plzInputPwdAgain')}, {validator: repeatValidator, message: repeatmsg}]")
        van-button(class="inherit_btn", native-type="submit", type="danger", block, round, :disabled='isDisabled') {{$t('sure')}}
    div(v-else)
      van-field(v-model="uid", label="引继ID", type='disabled')
      p 引继码创建成功！
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';
import { Toast } from 'vant';

export default {
  name: 'inherit',
  data(){
    return {
        newpwd: '',
        repeatpwd: '',
        isDisabled: false,
        showPageOne: true
    }
  },
  created(){
      
  },
  methods:{
    ...mapActions(['getUserInfo']),
    ...mapActions('user', ['inherit']),
    pwdValidator(val){
      if((val.length > 18 || val.length < 8) && /[^\a-\z\A-\Z]/g.test(val)){
        this.pwdmsg = this.$t('pwdInhPatternErr')
        return false
      }
    },
    onSubmit(){
        if(!this.isDisabled){
          this.inherit(Qs.stringify({
              uid: this.uid,
              deviceId: this.deviceId,
              accessToken: this.token,
              password: this.$md5(this.newpwd),
          }))
          this.isDisabled = true
        }
    },
    repeatValidator(val){
        if(val !== this.newpwd){
            this.repeatmsg = this.$t('pwdDontmatch');
            return false
        }
        return true
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'appid']),
    ...mapGetters('user', ['errmsg', 'inheritData', 'inheStatus']),
    pwdmsg: $vm => {
      return $vm.$t('pwdInhPatternErr')
    },
    repeatmsg: $vm => {
      return $vm.$t('pwdDontmatch')
    },
  },
  mounted(){
    this.$watch('inheStatus', val => {
      if(val === 'stated'){
        if(this.inheritData === 'success'){
          this.getUserInfo(Qs.stringify({
            appId: this.appid,
            uid: this.uid,
            deviceId: this.deviceId,
            accessToken: this.token
          }));
          this.$router.push({
            path: '/user/inheritComp',
            query: {
              email: this.email
            }
          });
        }
        this.isDisabled = false
      } else {
        this.isDisabled = false
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.inherit{
    margin: 20px;
    .inherit_form{
      margin-top: 20px;
      border-radius: 5px;
      box-shadow: 0px 0px 5px 2px #ebebeb;
    }
    .inherit_btn{
        margin-top: 20px;
        width: 90%;
        left: 5%;
        padding: 15px;
    }
}
</style>